import { isCustomDomain } from "./customDomains";

/* eslint-disable no-undef */
const getSubdomain = () => {
  // Get the full hostname
  const hostname = globalThis.location.hostname; // e.g., "subdomain.example.com"
  if (hostname === "192.168.1.31" || hostname === "localhost") {
    return "dev-upgraded";
  }
  // Split the hostname into parts
  const parts = hostname.split(".");

  // Check if there's a subdomain
  if (parts.length > 2) {
    // Return the subdomain
    return parts.slice(0, -2).join("."); // Join parts back to a string
  } else {
    alert("Please check the domain and try again");
    globalThis.location.href = "https://www.vlookup.ai";
  }
};
const xSimVAlue = getSubdomain();
export const imgPath = isCustomDomain(globalThis.location.hostname)
  ? process.env.REACT_APP_STATIC_IMAGE_PATH.replace(
      "{{subdomain}}.vlookup.ai",
      globalThis.location.hostname,
    )
  : process.env.REACT_APP_STATIC_IMAGE_PATH.replace("{{subdomain}}", xSimVAlue);
